import { NextTickTestComponent } from "./test-component";
import "./index.css";

export function App() {
  return <NextTickTestComponent />;
}
